<template>
  <div class="PromptCenter">
    <div v-show="visible" class="container-bg" @click.stop="handleClose">
        <div class="container">
            <div class="close"><img src="@/assets/icon_close.png" @click="handleClose"></div>
            <img class="content" :src="icon" @click="clickOpen(item)">
        </div>
    </div>
  </div>
</template>

<script>
/**
 * 弹出框
 */
import { cblockItem } from '@/api/app'
export default {
  name: 'PromptCenter',
  props: {
    list: {
      type: Array,
      default: () =>{
        return []
      }
    }
  },
  filters: {
  },
  watch: {
    list() {
      this.init()
    }
  },
  created() {
    this.decideShowAble()
    this.init()
  },
  data () {
    return {
      icon: '',
      item: {},
      visible: false,
      showable: true,
      expired: 3600000
    }
  },
  methods: {
    init(){
      if(this.list.length > 0 && this.list[0].hasOwnProperty('icon')){
        this.item = this.list[0]
        this.icon = this.list[0].icon
        this.visible = true&&this.showable
      }else{
        this.visible = false
      }
    },
    decideShowAble(){
      const key = 'center-popup'
      var expired = sessionStorage.getItem(key)
      var current = new Date().getTime()
      if(expired && expired > current){
        this.showable = false
        return
      }
      this.showable = true
      sessionStorage.setItem(key, current+this.expired)
    },
    handleClose() {
      this.visible = false
    },
    clickOpen: function(item){
      cblockItem(item, this)
      this.visible = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.PromptCenter{
  .container-bg{
    position:fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    .close{
      text-align: right;
      img{
        vertical-align: bottom;
      }
    }
    .content{
      width: 80vw;
    }
  }
}
</style>
